import { ACCESS_TOKEN, REFRESH_TOKEN } from '../constants/authConstants';
import { FIREBASE_TOKEN_SYNC_STATUS } from '../constants/commonConstants';
import { iAuthTokens } from '../types/userType';
import { getLocalStorageItem, removeItemFromLocalStorage, setLocalStorageItem } from './localStorageHelpers';

export const setAuthTokens = (authTokens: iAuthTokens) => {
  const { access, refresh } = authTokens;
  setLocalStorageItem(REFRESH_TOKEN, refresh.token);
  setLocalStorageItem(ACCESS_TOKEN, access.token);
};

export const getAccessToken = () => {
  const accessToken = getLocalStorageItem(ACCESS_TOKEN);
  return accessToken ? `Bearer ${accessToken}` : '';
};

export const getRefershToken = () => {
  return getLocalStorageItem(REFRESH_TOKEN) || '';
};

export const removeAuthTokens = () => {
  removeItemFromLocalStorage(REFRESH_TOKEN);
  removeItemFromLocalStorage(ACCESS_TOKEN);
  removeItemFromLocalStorage(FIREBASE_TOKEN_SYNC_STATUS);
};
